import axios from 'axios';

// @es lint doesnt want single export without default
export const Lint = 'leave me alone';

export const deleevAPI = axios.create({
  baseURL: process.env.VUE_APP_DELEEV_API_BASE_URL,
  timeout: 10000,
});
